import * as React from 'react';
import { NavLink } from 'react-router-dom';

import classNames from 'classnames';

import { ITabItemInternalProps } from './types';

import * as s from './TabItem.scss';

export class TabItemCommon extends React.Component<ITabItemInternalProps> {

	render() {
		const {
			onClick,
			active,
			className,
			title,
		} = this.props;

		return (
			<span
				onClick={onClick}
				className={classNames(
					s.container,
					{ [s.active]: active },
					className,
				)}
			>
				{title}
			</span>
		);
	}

}

export class TabItemLink extends React.Component<ITabItemInternalProps> {

	render() {
		const {
			onClick,
			url,
			className,
			title,
		} = this.props;

		return (
			<NavLink
				exact={true}
				onClick={onClick}
				to={url}
				className={classNames(
					s.container,
					className,
					// { ['active']: active },
				)}
				activeClassName={s.active}
			>
				{title}
			</NavLink>
		);
	}

}

export class TabItemHeader extends React.Component<ITabItemInternalProps> {

	render() {
		const {
			className,
			title,
			active,
		} = this.props;

		return (
			<h1
				className={classNames(
					s.container,
					className,
					{ ['active']: active },
				)}
			>
				{title}
			</h1>
		);
	}

}

export class TabItem extends React.Component<ITabItemInternalProps> {

	render() {
		const {
			url,
			active,
		} = this.props;

		return !!url
			? (active ? <TabItemHeader {...this.props}/> : <TabItemLink {...this.props}/>)
			: <TabItemCommon {...this.props}/>;
	}

}
